
import {  
  IonSlide,
  } from '@ionic/vue';

import { defineComponent } from 'vue';

import { ImagePanorama,Viewer } from 'panolens'; 

import { IonIcon } from '@ionic/vue';

import { chevronBackOutline, chevronForwardOutline} from 'ionicons/icons';

export default defineComponent({
  name: 'lightbox-item-360',
  components: {
     IonSlide,
     IonIcon

  },
  props: {
    active : {type:Boolean, default:true},
    type: {type:String},
    url: {type:String},
    title: {type:String},
    message: {type:String}
  },
  emits: ['prev', 'next'],
  data()
  {
    const viewer360: any = null;
    const panorama: any = null;
    
    return {viewer360, panorama , chevronBackOutline, chevronForwardOutline};
  },
  mounted()
  {
    console.log("lightbox360 mounted");

    this.loadPanorama();

  },
  unmounted()
  {
    console.log("lightbox360 unmounted");

    this.disposePanorama();
    
  },
  methods: {
    stop(ev)
    {
      console.log("stop event",ev);
    },
    loadPanorama()
    {
      
      if(this.viewer360 == undefined)
            {
                //console.log($("#viewer360"));
                this.viewer360 = new Viewer( { container: this.$refs.viewer360 as HTMLElement } );

            }

            // Keep one panorama
            if ( this.panorama ) { return; }

            const image = new Image();

            image.onload = () => {
              console.log("image is loaded");

              // Dynamically generate panorama
              this.panorama = new ImagePanorama( image);
              this.viewer360.add( this.panorama );

              this.viewerResize();

            };
            


            image.crossOrigin = "anonymous";
            image.src = this.url as string;
            
              //panorama = new PANOLENS.VideoPanorama( src, { autoplay: true } );

              //this.panorama.addEventListener( 'progress', function ( event ) {
              //const progress = event.progress.loaded / event.progress.total * 100;
              //console.log("Loading360 => " + progress);
              
              //if ( progress === 100 ) {
              //  console.log("Loading360 DONE => " + progress);
              //}

            //});
            
    },
    disposePanorama()
    {
      this.panorama.dispose();
      this.viewer360.remove( this.panorama );
      this.panorama = null;
    },
    viewerResize()
    {
      if(this.viewer360 != undefined)
      {
        const bounds = (this.$refs.viewer360 as any).getBoundingClientRect();
        //const bounds = (this.$refs.viewer360 as any).getClientRects();
        
        this.viewer360.onWindowResize(bounds.width, bounds.height);
      }
    },
    next()
    {
      this.$emit('next');
    },
    prev()
    {
      this.$emit('prev');
    }
  }
});








